import React from 'react'
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from '../Tabs/Tabs'
import HousekeepingTypePresenterTabContent from './HousekeepingTypePresenterTabContent'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

class HousekeepingTypePresenter extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      active_tab: 'general',
      housekeeping_type: this.props.housekeeping_type || [],
      new_record: this.props.new_record,
      housekeeping_type_create_path: this.props.housekeeping_type_create_path,
      housekeeping_type_save_path: this.props.housekeeping_type_save_path
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
	};

  /*******************
  * Render functions *
  ********************/

	render() {

    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: ['data-dismiss="modal"']
      },
    ]

		return (
			<div className="HousekeepingTypePresenter" ref="root">
        <Tabs tabs={this.Tabs()} />
				<div className="panel panel-form">
  				<ModalButtons loading={this.state.loading} buttons={buttons} />
          <HousekeepingTypePresenterTabContent   {...this.state} onChangeField={this.onChangeField} onChangeDescription={this.onChangeDescription} onChangeRoomType={this.onChangeRoomType}/>
  			  <LoadingSpinner show={this.state.loading} />
        </div>
			</div>
		);
  };

  Tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };
  
  /******************
  * Change handlers *
  *******************/

  onChangeActiveTab(name) {
    this.setState({active_tab: name});
  };
};

export default HousekeepingTypePresenter